import { render, staticRenderFns } from "./PatientSendMessage.vue?vue&type=template&id=6740d87c&scoped=true&lang=pug&"
import script from "./PatientSendMessage.vue?vue&type=script&lang=js&"
export * from "./PatientSendMessage.vue?vue&type=script&lang=js&"
import style0 from "./PatientSendMessage.vue?vue&type=style&index=0&id=6740d87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740d87c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VBtn,VCard,VCol,VContainer,VDivider,VRow})
